const SpecialisationJobs = [
  "Computer Networks Engineer",
  "Network Administrator",
  "Software Engineer ",
  "Software Developer",
  "Infrastructure Engineer",
  "Data Science Engineer ",
  "Data Analyst",
  "DevOps Engineer",
  "Powershell Developer",
  "Powershell Engineer",
  "Bash Engineer",
  "Shell Scripting Engineer",
  "Bash/Shell Engineer",
  "Cloud Engineer",
  "Cordova Developer",
  "Ionic Developer",
  "Backend Developer",
  "Golang Developer",
  "Senior Software Engineer",
  "Computer Vision Engineer",
  "NLP Engineer",
  "Game Developer ",
  "Unity Developer",
  "Unreal Engine Developer",
  "Cybersecurity Engineer",
  "UI/UX Designer ",
  "Computer Graphics Engineer",
  "IoT Engineer ",
  "Site Reliability Engineer ",
  "Web3 Developer",
  "BlockChain Developer",
  "Platform Engineer",
  "Web Developer",
  "Docker Engineer",
  "Kubernetes Engineer",
  "Kotlin Developer",
  "Kotlin Engineer",
  "Java Developer",
  "Java Software Engineer",
  "Typescript Developer",
  "Android Developer",
  "Database Administrator",
  "MySQL Engineer",
  "Power Bi Specialist",
  "Tableau Specialist",
  "Javascript Developer",
  "GraphQL Developer",
  "MLOps Engineer",
  "Database Architect",
  "SQL Engineer",
  "Laravel Developer",
  "Django Developer",
  "Arduino Engineer",
  "Raspberry Pi Engineer",
  "Linux Engineer",
  "Senior Linux Engineer",
  "Desktop Developer",
  "Frontend Developer",
  "FullStack Developer",
  "Python Developer",
  "IOS Developer",
  "IOS Engineer",
  "Flutter Developer",
  "React Native Developer",
  "React Native Engineer",
  "C++ Software Engineer",
  "C++  Developer",
  "Cuda Software Engineer",
  "React Developer",
  "React Engineer",
  "Angular Developer",
  "Nodejs Developer",
  "PHP Developer",
  "PHP Engineer",
  "FastAPI Developer",
  "Vuejs  Developer",
  "Nextjs Developer",
  "Svelte Developer",
  "Certified Ethical Hacker",
  "Ethical Hacker",
  "Cryptographic Engineer",
  "Reverse Engineer",
  "Forensics Engineer",
  "System Programmer",
  "System Administrator",
  "IT/CS Lecturer",
  "Orchestration Engineer",
  "Containerization Engineer",
  "Deep Learning Engineer",
  "Computer Studies Teacher",
  "Lead Backend Engineer",
  "Lead Fronted Developer",
  "CodeIgniter Developer",
  "ASP.NET Developer",
  "Elixir Developer",
  "Odoo Developer",
  "ERPNext Developer",
  "Elixir Engineer",
  "F# Software Engineer",
  "Nuxt Developer",
  "Remix Developer",
  "Alpine Developer",
  "Preact Developer",
  "Erlang Developer",
  "Scala Developer",
  "Groovy Developer",
  "Perl Software Developer",
  "Swift Engineer",
  "Swift Developer",
  "Objective-C Engineer",
  "Streamlit Developer",
  "Electron Developer",
  "Python Engineer",
  "ML/AI Engineer",
  "Lead Cloud Engineer",
  "Lead Software Engineer",
  "Backend Engineer",
  "C# Software Engineer",
  "Senior Backend Engineer",
  "Senior Frontend Engineer",
  "Golang Engineer",
  "Rust Engineer",
  "Rust Developer",
  "Ruby On Rails Developer",
  "Symphony Developer",
  "Assembly Engineer",
  "CMS Software Developer",
  "Statistical Programmer",
  "Spring Boot Developer",
  "Robotics Engineer",
  "Prompt Engineer",
  "Compiler Developer",
  "Senior Android Engineer",
  "Android Engineer",
  "Mobile App Developer",
  "Release Manager",
  "IT Consultant",
  "Applications Engineer",
  "Computer Programmer",
  "Solutions Architect",
  "Data Engineer",
  "Penetration Tester",
  "Cloud Architect",
  "Embedded Systems Engineer",
  "Bt Developer",
  "Computer Scientist",
  "Security Engineer",
  "Scrum Master",
  "Systems Analysts",
  "Frappe Developer",
  "IT Support Engineer",
  "Machine Learning Engineer",
  "IT Project Manager",
  "IT Manager",
  "Software Tester",  
  "Business Analyst",
  "Product Manager",
  "Cybersecurity Analyst",
  "Zero Matched",
].sort();

export default SpecialisationJobs;
